import { defineMessages } from "react-intl";

export const messages = defineMessages({
  edit: {
    id: "EAg8AF",
    defaultMessage: "Edit shipping price",
    description: "button to set a manual shipping price on a draft order",
  },
  title: {
    id: "ngu1af",
    defaultMessage: "Shipping price for this order",
    description: "manual shipping price popover title",
  },
  priceLabel: {
    id: "diGJre",
    defaultMessage: "Shipping price",
    description: "manual shipping price input label",
  },
  hint: {
    id: "eGYFVr",
    defaultMessage:
      "Applies to this order only. Picking another shipping method goes back to that method's price.",
    description: "manual shipping price hint",
  },
  manual: {
    id: "yhof0j",
    defaultMessage: "manual",
    description: "tag next to a manually set shipping price",
  },
  reset: {
    id: "W5ivBj",
    defaultMessage: "Use method price",
    description: "button to remove the manual shipping price",
  },
});
